import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import * as api from "api"
import { useIsDesktop } from "common/MediaQueries"
import SeoMetaData, { seoKeys } from "common/SeoMetaData"
import { StaticPropsFactoryProps } from "common/StaticPropsFactory"
import CitySearch from "components/ServiceCenters/CitySearch"
import ServiceCenterList from "components/ServiceCenters/ServiceCenterList"
import { ServiceCentersContext } from "components/ServiceCenters/ServiceCentersContext"
import StaticMap from "components/ServiceCenters/StaticMap"
import { GetStaticProps } from "next"
import { useState } from "react"

const Styled = {
  PageWrap: styled(Container)`
    display: flex;
  `,
  ContentSection: styled.section`
    width: 100%;
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 435px;
      flex-shrink: 0;
      border-inline-start: 1px solid ${(p) => p.theme.colors.silver};
    }
  `,
  Header: styled.div`
    color: ${(p) => p.theme.colors.marine};
    padding: 15px;

    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 41px;
      padding: 30px 25px;
      border-bottom: 1px solid ${(p) => p.theme.colors.silver};
    }

    ${(p) => p.theme.breakpoints.down("sm")} {
      box-shadow: 0 10px 20px 0 ${(p) => p.theme.colors.darkIndigo};
    }
  `,
  Headline: styled(Typography)`
    text-align: left; /* flipped by mui */
    margin: 20px 0;
  `,
  Subtitle: styled(Typography)`
    font-size: 14px;
    margin-bottom: 20px;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 16px;
    }
  `,
  MapSection: styled.section`
    flex: 1;
    position: sticky;
    top: var(--sticky-height);
    transition: top 221ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    align-self: flex-start;
  `,
}

type ServiceCentersProps = StaticPropsFactoryProps & {
  centers: api.ServiceCenter[]
}

export const getStaticProps: GetStaticProps<
  ServiceCentersProps,
  any
> = async () => {
  const seo = await api.getSeoKey(seoKeys.serviceCenters).then(api.extractData)
  const centers = (await api
    .getServiceCenter()
    .then(api.extractData)) as api.ServiceCenter[]
  return { props: { seo, centers }, revalidate: 60 }
}

const ServiceCenters = ({ centers, seo }: ServiceCentersProps) => {
  const [city, setCity] = useState("")
  const [inHesder, setInHesder] = useState(false)
  const [selectedCenter, setSelectedCenter] = useState<api.ServiceCenter>(null)
  const isDesktop = useIsDesktop()

  const cities = centers
    .map((item) => item.city)
    .filter((value, i, array) => array.indexOf(value) === i)
    .sort((a, b) => a.localeCompare(b))

  return (
    <>
      <SeoMetaData data={seo} />
      <Styled.PageWrap disableGutters>
        <ServiceCentersContext.Provider
          value={{
            city,
            cities,
            setCity,
            inHesder,
            setInHesder,
            centers,
            selectedCenter,
            setSelectedCenter,
          }}
        >
          <Styled.ContentSection>
            <Styled.Header>
              <Styled.Headline variant="h1">מרכזי שירות פורד</Styled.Headline>
              <Styled.Subtitle>
                לאיתור מרכז השירות הקרוב לאיזור מגורייך ולתיאום תור יש לבחור
                מהרשימה מטה
              </Styled.Subtitle>
              <CitySearch />
            </Styled.Header>
            <ServiceCenterList />
          </Styled.ContentSection>
          {isDesktop && (
            <Styled.MapSection>
              <StaticMap />
            </Styled.MapSection>
          )}
        </ServiceCentersContext.Provider>
      </Styled.PageWrap>
    </>
  )
}

export default ServiceCenters
